const iconButtons = document.querySelectorAll('.iconbtn[data-menu-target]');
const panels      = document.querySelectorAll('.flyout');
const iconbar     = document.getElementById('iconbar');
const btnHamb     = document.getElementById('btnToggleIconbar');
const backdrop    = document.getElementById('flyoutBackdrop');
const flyoutCap   = document.getElementById('flyoutCap');
const isMobile    = () => window.matchMedia('(max-width: 992px)').matches;

function showBackdrop(){ backdrop?.classList.add('show'); }
function hideBackdrop(){ backdrop?.classList.remove('show'); }
function showCap(){ flyoutCap?.classList.add('show'); }
function hideCap(){ flyoutCap?.classList.remove('show'); }

  function closeAllPanels(){
    panels.forEach(p => p.classList.remove('open'));
    iconButtons.forEach(b => b.classList.remove('with-arrow'));
    hideBackdrop();
    hideCap();
  }
  
  function openPanel(targetSel, button){
    closeAllPanels();
    const panel = document.querySelector(targetSel);
    if(panel) panel.classList.add('open');
    if(button) button.classList.add('with-arrow');
    showBackdrop();  // navbar + conteúdo ficam cinza
  }
  function closeIconbar(){
    iconbar.classList.remove('open');
    document.body.classList.remove('iconbar-open');
    btnHamb?.setAttribute('aria-expanded','false');
  }
  function toggleIconbar(){
    const opening = !iconbar.classList.contains('open');
    if(opening){
      iconbar.classList.add('open');
      document.body.classList.add('iconbar-open');
      btnHamb?.setAttribute('aria-expanded','true');
    }else{
      closeIconbar();
      if(isMobile()) closeAllPanels(); // mobile: fechar 1ª fecha 2ª
    }
  }

  // Hambúrguer
  btnHamb?.addEventListener('click', (e) => { e.preventDefault(); toggleIconbar(); });

  // Ícones (1º nível)
  iconButtons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const target = btn.getAttribute('data-menu-target');
      if(btn.classList.contains('with-arrow')) closeAllPanels();
      else openPanel(target, btn);
    });
  });

  // Botões "X" no flyout
  document.querySelectorAll('.close-flyout').forEach(b=>{
    b.addEventListener('click', closeAllPanels);
  });

  // Clique no backdrop
  backdrop?.addEventListener('click', () => {
    closeAllPanels();
    if(isMobile()) closeIconbar();
  });

  // Clique fora (fallback sem backdrop)
  document.addEventListener('click', (e) => {
    const insideFlyout  = e.target.closest('.flyout');
    const insideIconbar = e.target.closest('.iconbar');
    const insideNavbar  = e.target.closest('.appbar');
    const onBackdrop    = e.target.closest('.flyout-backdrop');
    if(onBackdrop) return;
    if(!insideFlyout && !insideIconbar && !insideNavbar){
      if(isMobile()) closeIconbar();
      closeAllPanels();
    }
  });

  // Resize: consistência
  window.addEventListener('resize', () => {
    if(isMobile() && !iconbar.classList.contains('open')){
      document.body.classList.remove('iconbar-open');
      closeAllPanels();
    }else if(!isMobile()){
      document.body.classList.remove('iconbar-open');
    }
  });

  // ESC fecha tudo
  document.addEventListener('keydown', (e)=>{
    if(e.key === 'Escape'){
      closeAllPanels();
      closeIconbar();
    }
  });